/**
 * MixedActionTable.cellClasses — shared cell-width constants for
 * MixedActionTable's row components.
 *
 * Split out from MixedActionTable.helpers.tsx so both it and
 * MixedActionTable.homogeneousRow.tsx can import the constants without a
 * circular dependency between the two row-component modules.
 */

/**
 * Width override for the narrow "chrome" columns (chevron, checkbox, status).
 * `!` beats the default `px-5 py-3` (size='sm') baked into `Table.Cell`.
 */
export const CHROME_CELL_CLASSES = '!w-12 !px-3';

/**
 * Medium fixed width used for the property / current / proposed columns in
 * homogeneous mode — wide enough for a pill or a short value plus an
 * ellipsis, narrow enough that the "Name" column gets the majority of the
 * remaining space via `flex-1` on the data cell.
 */
export const MEDIUM_CELL_CLASSES = '!w-36';

/**
 * Fixed width for the trailing edit column. Sized for the icon-only Edit
 * toggle (sm button, ~36px square) plus the cell's horizontal padding.
 */
export const EDIT_CELL_CLASSES = '!w-16 !px-3 text-right';

/** Head-only variant of `EDIT_CELL_CLASSES` — same width, no right-align. */
export const EDIT_HEAD_CLASSES = '!w-16 !px-3';
